import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import allReducers from './reducers';
import 'bootstrap/dist/css/bootstrap.css';


const Store = createStore(
  allReducers
)

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js